
import netOn from "asset/img/online_1.png";
import netOff from "asset/img/offline_1.png";
import netWait from "asset/img/onoffline_1.png";
import netWait2 from "asset/img/onoffline_2.png";

const statusImageMap = {
  'netOn': netOn,
  'netWait': netWait,
  'netWait2': netWait2,
  'netOff': netOff,
};

export default function NetStatusImg({netStatCd}) {

    const currentImageSrc = statusImageMap[netStatCd] || netOff;
    return (
        <img src={currentImageSrc} alt="" style={{ width: '24px' }} />
    )
}